import { Injectable, signal } from '@angular/core';
import { DetailPaneContext } from './context/detail.pane.context';

/** Child-record navigation inside one pane. The parent surface stays mounted beneath the child. */
@Injectable()
export class DetailPaneNavigation {
  private readonly target = signal<{ context: DetailPaneContext; backLabel: string } | null>(null);
  public readonly $target = this.target.asReadonly();
  private canLeave: () => Promise<boolean> = async () => true;

  public registerLeaveGuard(guard: () => Promise<boolean>): void {

    this.canLeave = guard;
  }

  public async open(context: DetailPaneContext, backLabel = 'Back'): Promise<boolean> {

    if (!await this.canLeave()) return false;
    this.target.set({ context, backLabel });
    return true;
  }

  public async back(): Promise<boolean> {

    if (!await this.canLeave()) return false;
    this.reset();
    return true;
  }

  public reset(): void {

    this.target.set(null);
  }
}
